import { Auth0Provider } from "@auth0/auth0-react";
import { PropsWithChildren } from "react";
import { useAuth0WithNavigate } from "./useAuth0WithNavigate";

export const Auth0WithNavigate = ({ children }: PropsWithChildren) => {
  const { searchParams, redirectCallback } = useAuth0WithNavigate();

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        redirect_uri: `${window.location.origin}/app`,
        login_hint: searchParams.get("email")?.toLowerCase() ?? undefined,
      }}
      onRedirectCallback={redirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};
